import { FC, useRef, useState } from "react";
import { FormInstance } from "antd";
import {
  AppButton,
  Form,
  FORM_FIELD_TYPES,
} from "site/ui/base";
import styled from "styled-components";
import { IUser } from "utils/types";
const Root = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
`
export interface IUserProfileData {
  firstName: string;
  lastName: string;
  email: string;
  password: string;
  confirmPassword: string;
}
export interface UserProfileFormProps {
  user?: IUser;
  onSave: (data: IUserProfileData) => Promise<IUser|undefined>;
}
export const UserProfileForm:FC<UserProfileFormProps> = ({
  onSave, user
}) => {
  const formRef = useRef<FormInstance<IUserProfileData>>(null);
  const [processing, setProcessing] = useState(false);
  const handleSubmit = (values: IUserProfileData) => {
    setProcessing(true);
    onSave(values).finally(() => setProcessing(false))
  }
  return (
    <Root>
      <Form
        formRef={formRef}
        items={[
          {
            fieldType: FORM_FIELD_TYPES.TEXT,
            itemProps: {
              name: "firstName",
              label: "First name",
              rules: [{ 
                required: true,
                message: "Please input your first name!",
              }],
            },
            fieldProps: {
              placeholder: "Esosa",
              size: "large",
            },
          },
          {
            fieldType: FORM_FIELD_TYPES.TEXT,
            itemProps: {
              name: "lastName",
              label: "Last name",
              rules: [{ 
                required: true, 
                message: "Please input your last name!" 
              }],
            },
            fieldProps: {
              placeholder: "Chiejine",
              size: "large",
            },
          },
        ]}
        formProps={{
          layout: "vertical",
          initialValues: user,
          onFinish: handleSubmit,
        }}
      />
      <AppButton loading={processing} variant="primary" size="large" onClick={() => formRef.current?.submit()}>Save</AppButton>  
    </Root>
  );
};